"use strict";


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/styled-components/lib/types.js
// module id = 14
// module chunks = 0